import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { authService } from '../../services/authService';

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();

  useEffect(() => {
    const handleCallback = async () => {
      try {
        // Get the code from URL search params
        const params = new URLSearchParams(window.location.search);
        const code = params.get('code');

        if (!code) {
          throw new Error('No code found in URL');
        }

        // Exchange the code for a session
        const response = await authService.handleOAuthCallback(code);
        
        if (response.error) throw response.error;
        if (!response.user) throw new Error('No user data received');
        
        // Set the user in context
        setUser(response.user);
        
        // Get the stored redirect path or default to home
        const redirectTo = sessionStorage.getItem('auth_redirect') || '/';
        sessionStorage.removeItem('auth_redirect');
        
        // Redirect to the appropriate page
        navigate(redirectTo, { replace: true });
      } catch (error) {
        console.error('[AuthCallback] Error:', error);
        navigate('/login', { 
          replace: true,
          state: { error: 'Authentication failed. Please try again.' }
        });
      }
    };

    handleCallback();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F1EAE1]">
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#361E06]" />
    </div>
  );
} 